import React, {Component} from "react";
import {dashboardService} from "../../../services/dashboard.service";
import {Alert, Button, ButtonGroup, Spinner} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import ActionButton from "../_components/ActionButton";
import {claimTypes} from "../../../constants/claim.constants";
import {Link} from "react-router-dom";
import PilotConference from "./PilotConference";

class PilotExhibitionStatePage extends Component {

    interval = null;

    state = {
        dashboard: null,
        exhibitionState: null
    }

    componentDidMount() {
        this.fetchDashboardData();

        this.interval = setInterval(() => {
            this.fetchDashboardData();
        },5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    fetchDashboardData = () => {
        dashboardService.getDashboard()
            .then((res) => {
                this.setState({
                    ...this.state,
                    dashboard: res
                })
            });
        dashboardService.readExhibitionState()
            .then((res) => {
                this.setState({
                    ...this.state,
                    exhibitionState: res
                })
            })
    }

    handleAction = (action, type = "GET") => {
        if(type === "GET") {
            dashboardService.getDashboardAction(action)
                .then(res => this.fetchDashboardData());
        }
        else {
            dashboardService.setPowerManagement(action)
                .then(res => this.fetchDashboardData());
        }

    }

    handleActionDaliEsSystemScene = (action) => {
        dashboardService.setDaliEsSystemScenes(action)
            .then(res => this.fetchDashboardData());
    }

    render() {
        const { t, data } = this.props;
        const { dashboard, exhibitionState } = this.state;

        let activeMode = null;

        const main = dashboard?.powerManagementList.find((x) => x.label == "Grupa domyślna");
        const conference = dashboard?.deviceGroups?.find((x) => x.label?.toLowerCase()?.includes("konferencja"))
        const cognor =  dashboard?.deviceGroups?.find((x) => x.label?.toLowerCase()?.includes("cognor"))
        const buttonStyle = {height: "70px"};

        console.log(conference);


        if(main?.groupState?.state?.toUpperCase() === "ON") activeMode = "MAIN"
        else if(conference?.manualTurnOn) activeMode = "CONFERENCE"
        else if(cognor?.manualTurnOn) activeMode = "COGNOR"
        else activeMode = null;

        console.log(activeMode);


        return(
            <>
                <div className="row">
                    <div className="col-md-12">

                        {!dashboard && (<Spinner animation={"grow"} />)}
                        {(activeMode === "MAIN" || activeMode === null) && dashboard?.powerManagementList.map((item, idx) => {
                                return (
                                    <div className="mt-2" key={idx}>
                                        <div className="card">
                                            <div className="card-header">
                                                <b><span
                                                    className="card-title"> Tryb: <b>Wystawa</b> </span></b>
                                            </div>
                                            {/*render card*/}
                                            {item ? (
                                                <div className="card-body">
                                                    {
                                                        (item?.groupState) ? (
                                                            <Alert
                                                                variant={!item.groupState.trigger.includes('manual') ? 'success' : 'warning'}>
                                                                <h6 className={"m-0"}>
                                                                    {!item.groupState.trigger.includes('manual') ?
                                                                        `${t(item.groupState.trigger.toLowerCase() + '-working')} | ${t('exhibition-state')} : ${t(item.groupState.state.toLowerCase())}` :
                                                                        `${t('manual-working')} | ${t('exhibition-state')} : ${t(item.groupState.state.toLowerCase())}`
                                                                    }
                                                                </h6>
                                                            </Alert>
                                                        ) : (
                                                            <Alert>
                                                                Loading
                                                            </Alert>
                                                        )}
                                                    <ButtonGroup size="lg" className="mx-0 d-flex flex-row" style={buttonStyle} >
                                                        <Button variant={'outline-secondary'}
                                                                active={(item.groupState.state.toLowerCase() === "on") && item.groupState.trigger.includes('manual')}
                                                                onClick={() => this.handleAction(`ManualSetState/on?groupid=${item.deviceGroupId}`, "PATCH")}>
                                                            Włącz wystawę
                                                        </Button>
                                                        <Button variant={'outline-secondary'}
                                                                active={(item.groupState.state.toLowerCase() === "off") && item.groupState.trigger.includes('manual')}
                                                                onClick={() => this.handleAction(`ManualSetState/off?groupid=${item.deviceGroupId}`, "PATCH")}>
                                                            Wyłącz wystawę
                                                        </Button>
                                                    </ButtonGroup>
                                                </div>
                                            ) : (
                                                <div className="card-body">
                                                    <Spinner animation={"border"}/>
                                                </div>
                                            )}
                                            {/*render card end */}
                                        </div>
                                    </div>
                                )
                            }
                        )}

                        { cognor && dashboard && (activeMode === "COGNOR" || activeMode === null) && (
                            <div className="mt-2" >
                                <div className="card">
                                    <div className="card-header">
                                        <b><span
                                            className="card-title"> Tryb: <b> {cognor.label}</b> </span></b>
                                    </div>
                                    {/*render card*/}
                                    <div className="card-body">
                                        <Alert
                                            variant={cognor.manualTurnOn ? 'success' : 'warning'}>
                                            <h6 className={"m-0"}>
                                                { !cognor.manualTurnOn ? 'Wyłaczony' : `Włączony`}
                                            </h6>
                                        </Alert>
                                        <ButtonGroup size="lg" className="mx-0 d-flex flex-row" style={buttonStyle} >
                                            <Button variant={'outline-secondary'}
                                                    active={cognor.manualTurnOn}
                                                    onClick={() => this.handleAction(`turnonpcgroup/${cognor.id}`)}>
                                                Włącz tryb COGNOR
                                            </Button>
                                            <Button variant={'outline-secondary'}
                                                    active={!cognor.manualTurnOn}
                                                    onClick={() => this.handleAction(`RestoreScheduleDeviceGroup/${cognor.id}`, "PATCH")}>
                                                Wyłącz  tryb COGNOR
                                            </Button>
                                        </ButtonGroup>
                                </div>
                                    {/*render card end */}
                                </div>
                            </div>
                        )}


                        { conference && dashboard && (activeMode === "CONFERENCE" || activeMode === null) && (
                            <PilotConference
                                data={data}
                                deviceGroup={conference}
                                screnarionSettings={dashboard.exhibitionScenarioSettings}
                                reload={this.fetchDashboardData}
                            />
                        )}

                        {data.customActions?.renderList.filter((item) => item.render === true).length > 0 && (
                            <div className="mt-4">
                                <h4>Akcje dodatkowe</h4>
                                {data.customActions?.renderList.map((item, idx) => {
                                    return (
                                        <ActionButton
                                            key={idx}
                                            variant="primary"
                                            size={"lg"}
                                            actionType={item.type}
                                            actionKey={item.key}
                                            actionValue={item.value}
                                            data={data}>
                                            {item.label}
                                        </ActionButton>)
                                })}
                            </div>
                        )}
                    </div>

                    {/*<div className="col-md-6">*/}
                    {/*    <h4>Panel Przewodnika</h4>*/}
                    {/*    <Link to={'/pilot/lista'} className="btn btn-pilot-first btn-pilot-first-bg m-1">*/}
                    {/*        STEROWANIE STANOWISKAMI*/}
                    {/*    </Link>*/}
                    {/*</div>*/}
                </div>
            </>
        )
    }
}

export default withNamespaces()(PilotExhibitionStatePage);
